import Stripe from 'stripe'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import getStripeCustomer from './get-stripe-customer'
import {STRIPE_SECRET_KEY, TEST_STRIPE_SECRET_KEY} from '../../../constants'

/**
 ** Creates a payment method for Stripe based on elements and event and attach it to stripe customer ID.
 * @async
 * @param {Object} basket - The basket object containing order details.
 * @param {Object} customer - The customer object containing customer details.
 * @param {Function} updateCustomerMutation - The function to update customer information.
 * @param {Function} getcustomPreferencevalue - Site preference.
 * @param {Object} stripe - Stripe object for triggering createPaymentMethod.
 * @param {Object} elements - Payment element.
 * @param {Object} event - Event object returned to onConfirm event listener.
 * @returns {Object} - It returns object containing details about the Payment Method.
 * @throws {Error} If there's an error during the payment intent creation process.
 */
const CreatePaymentMethod = async (
    basket,
    customer,
    updateCustomerMutation,
    getcustomPreferencevalue,
    stripe,
    elements,
    event
) => {
    const configs = getConfig()
    const instanceName = configs?.app?.library?.instanceName
    const stripeSecretKey = instanceName === 'PROD' ? STRIPE_SECRET_KEY : TEST_STRIPE_SECRET_KEY
    const stripeAPI = Stripe(stripeSecretKey)

    // Create customer ID and update it in the customer profile
    const stripeCustomerId = await getStripeCustomer(
        stripeAPI,
        basket?.shipments[0]?.shippingAddress?.fullName,
        customer,
        updateCustomerMutation
    )

    if (!stripeCustomerId) {
        throw new Error('Failed to create or retrieve Stripe customer ID')
    }

    const paymentMethod = await stripe.createPaymentMethod({
        elements,
        params: {
            billing_details: {
                name: event?.billingDetails?.name
            }
        }
    })

    if (!paymentMethod) {
        throw new Error('Failed to create payment method')
    }

    if (paymentMethod?.paymentMethod?.id)
        await stripeAPI.paymentMethods.attach(paymentMethod?.paymentMethod?.id, {
            customer: stripeCustomerId
        })

    return paymentMethod
}

export default CreatePaymentMethod
